import { ModalBasic } from "../../../../shared/components/ModalBasic";
import { GenericAutocomplete } from "../../../../common/GenericAutocomplete";
import { NormalizedStorageObject } from "../../../../services/api/instances/storageApi/types/object_types";
import { SaveFileValue } from "../../../../services/api/instances/saveFileApi/types";
import { useCreateSchemaObjectModal } from "../../hooks/use-create-schema-object-modal";
import { AppLabel } from "../../../../shared/components/AppLabel";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.css";
import { useModalSelectors } from "../../../../app/state/modalSlice/hook/use-modal-selectors";
import { AppNewInput } from "../../../../shared/components/AppNewInput";
import { useEffect, useRef } from "react";

export const CreateSchemaObjectModal = () => {
  const createSchemaModal = useModalSelectors("create_schema_object_modal");
  const {
    name,
    selectedFile,
    filteredSchemas,
    handleCloseModal,
    handleModalAction,
    handleChangeName,
    handleSelectSchemaFile,
  } = useCreateSchemaObjectModal(createSchemaModal);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (createSchemaModal.isOpen) {
      const timer = setTimeout(() => {
        const input = inputRef.current;
        if (input) {
          input.focus();
        }
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [createSchemaModal.isOpen]);

  return (
    <ModalBasic
      open={createSchemaModal.isOpen}
      closeModal={() => handleCloseModal("create_schema_object_modal")}
      onClose={() => handleCloseModal("create_schema_object_modal")}
      buttonOkText={t("schemas.create_object")}
      onOk={handleModalAction}
      onCancel={() => handleCloseModal("create_schema_object_modal")}
      hasFooter
    >
      <div className={styles["body"]}>
        <div>
          <AppLabel>Введите имя</AppLabel>
          <AppNewInput
            ref={inputRef}
            value={name}
            onChange={handleChangeName}
          />
        </div>
        <AppLabel>{t("schemas.create_object_modal_label")}</AppLabel>
        <GenericAutocomplete<NormalizedStorageObject<SaveFileValue>>
          options={filteredSchemas}
          value={selectedFile}
          onChange={(newValue) => handleSelectSchemaFile(newValue)}
          emptyOptionLabel={t("schemas.without_schema_option")}
          getLabel={(schema) => schema.friendly_name}
          getValue={(schema) => schema.id}
          getOptionKey={(schema) => schema.ref}
          autocompleteStyle={"select"}
        />
      </div>
    </ModalBasic>
  );
};
